import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './appData.html'

/**
 * Administer Configurations route
 *
 * @namespace routes.AdminConfigurations
 * @type {TmrRoute}
 */
export const route = {
  name: 'admin.settings.appData.list',
  label: 'ADMIN.APPDATA.TITLE',
  url: '/app',
  component: 'tmrAdminAppData',
  resourceType: 'AppData',
  resourceList: {
    searchParameters: ['code', 'value'],
  },
}

/**
 * Component for {@link routes.tmrAdminAppData Administer Application Data route}
 *
 * @type {ngComponent}
 */
export const tmrAdminAppData = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
}
